import { Injectable, inject } from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';
import { map, catchError } from 'rxjs/operators';
import { throwError } from 'rxjs';
import { FilterMetadata, SortMeta } from 'primeng/api';
import { environment } from '../../../environments/environment';
import { TipoMaterial } from '../../domain/tipo-material.domain';

@Injectable({
  providedIn: 'root'
})
export class TipoMaterialService {
  protected http = inject(HttpClient);
  protected apiUrl: string = `${environment.URL_API}/tipo-materials`;

  findAll(
    paginate: boolean,
    page: number,
    size: number,
    termino: string,
    multiSortMeta: SortMeta[] | undefined,
    filtersMetadata: any,
    accept: string = ''
  ): Observable<any> {
    // El interceptor HTTP maneja automáticamente Accept: application/ld+json para listados
    let httpOptions: any = {};

    // Solo sobrescribir si se solicita explícitamente application/json
    if (accept !== undefined && accept !== null && accept !== '' && accept === 'json') {
      httpOptions = {
        headers: new HttpHeaders({ Accept: 'application/json' })
      };
    }

    let url = `${this.apiUrl}?size=${size}&page=${page}`;

    if (paginate !== undefined && !paginate) {
      url = `${this.apiUrl}?pagination=false`;
    }

    // Ordenamiento
    if (multiSortMeta !== undefined && multiSortMeta !== null && multiSortMeta.length > 0) {
      multiSortMeta.forEach((element: SortMeta) => {
        let direction = 'asc';
        if (element.order === -1) {
          direction = 'desc';
        }
        url += `&_order[${element.field}]=${direction}`;
      });
    }

    // Filtro global (q)
    if (termino !== undefined && termino !== null && termino.trim() !== '') {
      url += `&q=${encodeURIComponent(termino.trim())}`;
    }

    // Filtros
    if (filtersMetadata !== undefined && filtersMetadata !== null) {
      Object.keys(filtersMetadata).forEach((property) => {
        const filter: any = filtersMetadata[property];
        if (filter !== undefined && filter instanceof Array) {
          filter.forEach((element: FilterMetadata) => {
            if (element.value !== null && element.value !== undefined && element.value !== '') {
              url += `&${property}=${encodeURIComponent(element.value)}`;
            }
          });
        }
        if (filter !== undefined && filter instanceof Object && !(filter instanceof Array)) {
          if (filter.value !== null && filter.value !== undefined && filter.value !== '') {
            url += `&${property}=${encodeURIComponent(filter.value)}`;
          }
        }

      });
    }

    return this.http.get(url, httpOptions).pipe(
      map((response: any) => {
        return response;
      }),
      catchError((error: any) => {
        console.error('Error en TipoMaterialService:', error);
        return throwError(() => error);
      })
    );
  }

  getAll(params?: HttpParams): Observable<any> {
    return this.http.get(this.apiUrl, { params });
  }

  getById(id: number | string): Observable<TipoMaterial> {
    return this.http.get<TipoMaterial>(`${this.apiUrl}/${id}`);
  }

  create(entity: TipoMaterial): Observable<TipoMaterial> {
    return this.http.post<TipoMaterial>(this.apiUrl, entity);
  }

  update(id: number | string, entity: Partial<TipoMaterial>): Observable<TipoMaterial> {
    const headers = new HttpHeaders({
      'Content-Type': 'application/merge-patch+json'
    });
    return this.http.patch<TipoMaterial>(`${this.apiUrl}/${id}`, entity, { headers });
  }

  patch(id: number | string, entity: Partial<TipoMaterial>): Observable<TipoMaterial> {
    const headers = new HttpHeaders({
      'Content-Type': 'application/merge-patch+json'
    });
    return this.http.patch<TipoMaterial>(`${this.apiUrl}/${id}`, entity, { headers });
  }

  delete(id: number | string): Observable<void> {
    return this.http.delete<void>(`${this.apiUrl}/${id}`);
  }
}